/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `resultsLimitOptions` for the Caintra Connect frontend.
 * @module utils/resultsLimitOptions
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */

export const RESULTS_LIMIT_VALUES = [10, 20, 50];
export const DEFAULT_RESULTS_LIMIT = RESULTS_LIMIT_VALUES[0];

/**
 * Builds react-select options for the results-per-page dropdown.
 * @param {(key: string, options?: object) => string} t - i18n translate function
 * @returns {Array<{ value: number, label: string }>}
 */
export const getResultsLimitOptions = (t) =>
  RESULTS_LIMIT_VALUES.map((value) => ({
    value,
    label: t("common.resultsCount", { count: value }),
  }));
